function isSameDate(a: Date, b: Date) {
    return a < b ? false : a > b ? false : true;
}

export default isSameDate;
